var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcelDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 20,
    fill: "#D7D7D7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Version 2.0 - Under Review"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2474 -6450C-2474 -6451.1 -2473.1 -6452 -2472 -6452H18919C18920.1 -6452 18921 -6451.1 18921 -6450V6022C18921 6023.1 18920.1 6024 18919 6024H-2472C-2473.1 6024 -2474 6023.1 -2474 6022V-6450Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2472 -6451H18919V-6453H-2472V-6451ZM18920 -6450V6022H18922V-6450H18920ZM18919 6023H-2472V6025H18919V6023ZM-2473 6022V-6450H-2475V6022H-2473ZM-2472 6023C-2472.55 6023 -2473 6022.55 -2473 6022H-2475C-2475 6023.66 -2473.66 6025 -2472 6025V6023ZM18920 6022C18920 6022.55 18919.6 6023 18919 6023V6025C18920.7 6025 18922 6023.66 18922 6022H18920ZM18919 -6451C18919.6 -6451 18920 -6450.55 18920 -6450H18922C18922 -6451.66 18920.7 -6453 18919 -6453V-6451ZM-2472 -6453C-2473.66 -6453 -2475 -6451.66 -2475 -6450H-2473C-2473 -6450.55 -2472.55 -6451 -2472 -6451V-6453Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "NX_1366x768 - 24",
    clipPath: "url(#clip0_1_140)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1366,
    height: 768,
    transform: "translate(-1098 -206)",
    fill: "#F0F4F5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2131",
    x: -967.5,
    y: -21.5,
    width: 1185,
    height: 563,
    fill: "white",
    stroke: "#F2F2F4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 5127"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4911"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-excel 1",
    clipPath: "url(#clip1_1_140)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.851 4.16602H10.8848V15.8327H17.851C18.0905 15.8327 18.2864 15.6452 18.2864 15.416V4.58268C18.2864 4.35352 18.0905 4.16602 17.851 4.16602Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.9325 6.25H16.9802V7.5H13.9325V6.25ZM13.9325 10.4167H16.9802V11.6667H13.9325V10.4167ZM13.9325 12.5H16.9802V13.75H13.9325V12.5ZM13.9325 8.33333H16.9802V9.58333H13.9325V8.33333ZM10.8848 6.25H13.0617V7.5H10.8848V6.25ZM10.8848 10.4167H13.0617V11.6667H10.8848V10.4167ZM10.8848 12.5H13.0617V13.75H10.8848V12.5ZM10.8848 8.33333H13.0617V9.58333H10.8848V8.33333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.7555 17.5L2.61234 15.8333V4.16667L11.7555 2.5V17.5Z",
    fill: "url(#paint0_linear_1_140)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.32901 12.9173L7.27972 11.0173C7.24054 10.9465 7.197 10.8173 7.15781 10.6257H7.1404C7.11863 10.7173 7.07509 10.8507 7.00107 11.034L5.94743 12.9173H4.31036L6.2522 10.0007L4.47581 7.08398H6.14771L7.01849 8.83398C7.08815 8.97148 7.14911 9.13815 7.20135 9.32565H7.21877C7.2536 9.21315 7.31455 9.04232 7.41034 8.81732L8.38126 7.08398H9.90948L8.08084 9.97565L9.96172 12.9173H8.33337H8.32901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M18.8088 14.6154H20.8987L17.2414 20L13.5842 14.6154H15.674V10H18.8088V14.6154Z",
    fill: "#F58120"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_140",
    x1: 2.61234,
    y1: 10,
    x2: 11.7555,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21AD64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#088242"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1366,
    height: 768,
    fill: "white",
    transform: "translate(-1098 -206)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.8987,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelDownload);
export default __webpack_public_path__ + "static/media/ExcelDownload.c0d6f175046c53781e0617fe036f524b.svg";
export { ForwardRef as ReactComponent };